module.exports = __webpack_public_path__ + "fonts/Golos-Text_Black.d663ad4.woff2";